import React, { Component } from "react";
import PropTypes from "prop-types";
import icon_cpf from "../images/icone-cpf-invalido.png";
import identification from "../images/identification.png";
import Footer from "../components/Footer/Footer.js";

export class CpfValidation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cpf: "",
      showError: false,
    };
  }

  _handleKeyUp = (e) => {
    if (e.key === "Enter" && this.state.cpf.replace(/[^a-z0-9]/gi, "").length === 11) {
      this.handleClick();
    }
  };

  handleClick(e) {
    console.log(this.props.cpf, this.state.cpf);
    if (this.state.cpf == this.props.cpf) {
      //this.setState({ showError: false });
      this.props.success();
    } else {
      this.setState({ showError: true });
    }
  }

  _onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, showError: false });
  };

  render() {
    return (
      <div className="container h-100">
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5 ">
            <img src={identification} style={{ maxHeight: "100px", height: "100%" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            <h5 className="mt-4 card-text text-light fw-bold">IDENTIFICAÇÃO</h5>
            <h5 className="mt-5 card-text text-light mb-4">Para prosseguir precisamos que insira o seu CPF para realizar a identificação</h5>

            {this.state.showError && (
              <div className="d-flex align-items-center justify-content-center text-danger mb-1">
                <img src={icon_cpf} style={{ maxHeight: "30px" }} alt="" />
                <span>CPF inválido - Verifique e tente novamente</span>
              </div>
            )}
            <div className="col-8 d-grid" style={{ margin: "auto" }}>
              {/* <MaskedInput mask="111.111.111-11" name="cpf" size="20" className="text-dark text-center" onChange={this._onChange} onKeyUp={this._handleKeyUp} /> */}

              <input
                type="text"
                name="cpf"
                size="20"
                maxLength="14"
                className="text-dark text-center"
                value={this.state.cpf}
                onChange={(e) => {
                  // Remove tudo que não for número
                  let value = e.target.value.replace(/\D/g, "");
                  // Aplica a máscara: 111.111.111-11
                  value = value
                    .replace(/^(\d{3})(\d)/, "$1.$2")
                    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
                    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
                  this.setState({ cpf: value, showError: false });
                }}
                onKeyUp={this._handleKeyUp}
              />
            </div>
            <h5 className="mt-4 card-text text-light mb-4">Se o documento estiver corretamente em seu CPF, você poderá realizar a sua assinatura.</h5>
            <div className="row justify-content-center" style={{ margin: "auto" }}>
              <div className="mt-4 mb-4 col-4 d-grid">
                <button className="mt-4 btn btn-primary fw-bold" disabled={this.state.cpf.replace(/[^a-z0-9]/gi, "").length !== 11} type="button" onClick={() => this.handleClick()}>
                  Prosseguir
                </button>
              </div>
            </div>
            <div className="mt-5">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CpfValidation.propTypes = {
  cpf: PropTypes.string,
  success: PropTypes.func.isRequired,
};

export default CpfValidation;
